import React, { useState } from "react";
import { Grid, Typography, Box, Radio } from "@mui/material";
import BoardingImg1 from '../img/boarding-icon1.png'
import dayjs from "dayjs";

const DroppingPoints = ({ droppingpoint, formik }) => {
    const { setFieldValue, values } = formik;

    const handleSelect = (id) => {
        setFieldValue("droppingPoint", id)
    };

    return (
        <Grid container spacing={2}>
            <Grid size={{ md: 12, xs: 12 }}>
                <Typography
                    sx={{
                        fontFamily: '"Segoe UI", sans-serif',
                        fontSize: '17px',
                        fontWeight: 600,
                        color: '#0e182b',
                    }}
                >
                    <img src={BoardingImg1} alt="" style={{ verticalAlign: 'sub', marginRight: '10px' }} />
                    Dropping Points
                </Typography>
                <Typography
                    sx={{
                        fontFamily: '"Segoe UI", sans-serif',
                        fontSize: '15px',
                        color: '#364252',
                    }}
                >
                    Select your dropping point from the list below
                </Typography>
            </Grid>

            {droppingpoint && droppingpoint.map((item, i) => (
                <Grid size={{ md: 12, xs: 12 }}>
                    <Box key={item.boarding_point_id} onClick={() => handleSelect(item.boarding_point_id)} sx={{
                        padding: '13px 5px',
                        borderRadius: '12px',
                        border: '1px solid #e5e5e5',
                        width: '100%',
                    }}>
                        <Grid sx={{ display: 'flex' }}>
                            <Grid sx={{ marginRight: '5px' }}>
                                <Box
                                    sx={{
                                        position: "relative",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "25px", "&::before": {
                                            content: '""',
                                            position: "absolute",
                                            top: '21px',
                                            bottom: 0,
                                            left: "50%",
                                            width: "1px",
                                            backgroundColor: "#364252",
                                            transform: "translateX(-50%)",
                                            zIndex: 0,
                                            height: '35px',
                                        },
                                    }}
                                >
                                    <Radio
                                        checked={values?.droppingPoint === item.boarding_point_id}
                                        onChange={() => handleSelect(item.boarding_point_id)}
                                        value={values?.droppingPoint}
                                        sx={{
                                            position: "relative",
                                            zIndex: 1,
                                            "& .MuiSvgIcon-root": {
                                                fontSize: 24,
                                            },
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Grid sx={{ width: '70px' }}>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '17px',
                                    fontWeight: 600,
                                    textAlign: 'left',
                                    color: '#0e182b',
                                }}>

                                    {((item?.bording_time).split(' ')[1]).slice(0, 5)}
                                </Typography>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '12px',
                                    fontWeight: 'normal',
                                    textAlign: 'left',
                                    color: '#364252',
                                }}>
                                    {dayjs((item?.bording_time).split(' ')[0]).format("MMM D")}
                                    {/* {(item?.bording_time).split(' ')[0]} */}
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '17px',
                                    fontWeight: 600,
                                    textAlign: 'left',
                                    color: '#0e182b',
                                }}>{item?.boarding_point_name}</Typography>
                                <Typography sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '12px',
                                    fontWeight: 'normal',
                                    textAlign: 'left',
                                    color: '#364252',
                                }}>
                                    {item?.boarding_point_name}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            ))}
        </Grid>
    );
};

export default DroppingPoints;
